import axios from "axios";
import httpAdapter from "axios/lib/adapters/http";

import Session from "./session";
import UserResource from "./users";
import DeviceResource from "./devices";
import SiteGroupResource from "./site_groups";
import MeasureResource from "./measures";
import ConstructionSiteResource from "./construction_sites";

const instance = axios.create({
  baseURL: process.env.VUE_APP_WEB_API_URL,
  adapter: httpAdapter,
  withCredentials: true,
});

instance.interceptors.request.use(function(config) {
  config.headers["Authorization"] =
    "Token " + localStorage.getItem("user-token");
  return config;
});

export default {
  updateNotification(measureId, notification) {
    const updateParams = {
      enabled: notification.enabled,
    };

    return instance
      .patch(`/measures/${measureId}/notification`, {
        notification: updateParams,
      })
      .then((resp) => resp.data);
  },
  addNotificationAddress(measureId, address) {
    const createParams = {
      email: address,
    };

    return instance
      .post(`/measures/${measureId}/notification/addresses`, {
        address: createParams,
      })
      .then((resp) => resp.data);
  },
  deleteNotificationAddress(measureId, { email }) {
    return instance.delete(
      `/measures/${measureId}/notification/addresses?email=${email}`
    );
  },
  auth: new Session(instance),
  users: new UserResource(instance),
  devices: new DeviceResource(instance),
  site_groups: new SiteGroupResource(instance),
  measures: new MeasureResource(instance),
  construction_sites: new ConstructionSiteResource(instance),
};
